import React from 'react';
import { View } from 'react-native';

// Small safety wrapper: if a caller accidentally passes `pointerEvents` as a prop
// (common when spreading incoming props), move it into the `style` prop so
// react-native-web doesn't emit the deprecated "props.pointerEvents is deprecated" warning.
// This component is safe to use in place of `View` in places where props may be
// forwarded from higher-level containers.
const SafeView: React.FC<any> = (props) => {
  try {
    const { pointerEvents, style, ...rest } = props || {};
    if (typeof pointerEvents === 'undefined') {
      return <View {...rest} style={style} />;
    }
    // Merge pointerEvents into style conservatively
    let mergedStyle: any;
    if (Array.isArray(style)) mergedStyle = [...style, { pointerEvents }];
    else if (style && typeof style === 'object') mergedStyle = { ...style, pointerEvents };
    else mergedStyle = { pointerEvents };
    return <View {...rest} style={mergedStyle} />;
  } catch (e) {
    // Fallback to plain View if anything unexpected happens
    return <View {...props} />;
  }
};

export default SafeView;
